import { useNotification } from './NotificationSystem';

/**
 * Hook personalizado para usar notificaciones con mensajes comunes
 */
export const useNotifications = () => {
  const { addNotification } = useNotification();

  return {
    success: (message) => addNotification(message, 'success', 3500),
    error: (message) => addNotification(message, 'error', 4000),
    warning: (message) => addNotification(message, 'warning', 3500),
    info: (message) => addNotification(message, 'info', 3000),
  };
};

export default useNotifications;
